const DNI_REGEX = /^(\d{8})([A-Z])$/;
const CIF_REGEX = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/;
const NIE_REGEX = /^[XYZ]\d{7,8}[A-Z]$/;
const LETTER_ABEH_REGEX = /[ABEH]/u;
const LETTER_KPQS_REGEX = /[KPQS]/u;

export const validateSpanishId = (() => {
  function spainIdType(str) {
    if (str.match(DNI_REGEX)) {
      return 'dni';
    }
    if (str.match(CIF_REGEX)) {
      return 'cif';
    }
    if (str.match(NIE_REGEX)) {
      return 'nie';
    }
    return undefined;
  }

  function validDni(dni) {
    const dniLetters = 'TRWAGMYFPDXBNJZSQVHLCKE';
    const letter = dniLetters.charAt(Number.parseInt(dni, 10) % 23);
    return letter === dni.charAt(8);
  }

  function validNie(nie) {
    let niePrefix = nie.charAt(0);
    switch (niePrefix) {
      case 'X':
        niePrefix = 0;
        break;
      case 'Y':
        niePrefix = 1;
        break;
      case 'Z':
        niePrefix = 2;
        break;
      default:
        niePrefix = '';
    }
    return validDni(String(niePrefix) + nie.substring(1));
  }

  function validCif(cif) {
    const match = cif.match(CIF_REGEX);
    if (!match) {
      return false;
    }

    const letter = match[1];
    const number = match[2];
    const control = match[3];

    let evenSum = 0;
    let oddSum = 0;

    for (let i = 0; i < number.length; i++) {
      let n = Number.parseInt(number[i], 10);

      if (i % 2 === 0) {
        n *= 2;
        oddSum += n < 10 ? n : n - 9;
      } else {
        evenSum += n;
      }
    }

    const controlDigit =
      10 - Number.parseInt((evenSum + oddSum).toString().slice(-1), 10);
    const controlLetter = 'JABCDEFGHI'.charAt(controlDigit);

    if (LETTER_ABEH_REGEX.test(letter)) {
      return control === String(controlDigit);
    }
    if (LETTER_KPQS_REGEX.test(letter)) {
      return control === controlLetter;
    }
    return control === String(controlDigit) || control === controlLetter;
  }

  return (str) => {
    const clean = str.toUpperCase().replace(/\s+/gu, '');
    const type = spainIdType(clean);

    if (!type) {
      return { type: undefined, valid: false };
    }

    let valid = false;
    switch (type) {
      case 'dni':
        valid = validDni(clean);
        break;
      case 'nie':
        valid = validNie(clean);
        break;
      case 'cif':
        valid = validCif(clean);
        break;
      default:
        valid = false;
    }

    return !!type && !!valid;
  };
})();
